// extracted by mini-css-extract-plugin
export default {"container":"CustomForm-module__container-OALbCW","card":"CustomForm-module__card-bIhfdZ"};